<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>

      <VCardTitle>{{ contractItem.productName }}</VCardTitle>
      <VCardSubtitle class="mt-0 pb-0" :style="{ color: statusColor }">{{
        $t(`contractDivisionStatus.${contractItem.statusType}`)
      }}</VCardSubtitle>
      <VCardText>
        <VList dense class="pt-0 mb-0">
          <VListItem class="px-0 pt-0 mb-2">
            <VListItemContent>
              <VListItemTitle class="mt-2"
                >{{ $t("productGroup") }}:
                {{ contractItem.productGroupName }}</VListItemTitle
              >
              <VListItemTitle class="mt-2"
                >{{ $t("typeProduct") }}:
                {{ contractItem.productTypeName }}</VListItemTitle
              >
              <VListItemTitle
                class="mt-2"
                style="white-space: normal"
                v-if="contractItem.attrs"
                >{{ $t("attributes") }}:
                {{ contractItem.attrs.join(", ") }}</VListItemTitle
              >
              <VListItemTitle class="mt-2"
                >{{ $t("count") }}: {{ contractItem.contractItemCount }}
                {{ contractItem.unit_type_name }}</VListItemTitle
              >
            </VListItemContent>
          </VListItem>
          <div
            class="d-flex justify-space-between align-center"
            v-for="initiator in initiators"
            :key="initiator.id"
          >
            <VCardSubtitle class="mt-0 pb-0 pt-1 px-0">
              {{ initiator.initiator }}
            </VCardSubtitle>
            <div class="d-flex align-center">
              <VBtn
                class="new_style"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.REJECTED &&
                  contractItem.statusType === INITIATOR_STATUS_TYPE.WAITING
                "
                @click="openRejectItemDetailsDialog(initiator.id)"
              >
                <VueIcon icon="newEyeIcon"></VueIcon>
              </VBtn>
              <VueIcon
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.ACCEPTED ||
                  initiator.statusType === INITIATOR_STATUS_TYPE.PART_ACCEPTED
                "
                class="mt-3 mr-3"
                icon="checkIcon"
                fill="#68B833"
              ></VueIcon>
              <VueIcon
                v-if="initiator.statusType === INITIATOR_STATUS_TYPE.REJECTED"
                class="ml-2 mr-3 mt-3"
                width="12px"
                icon="cancelIcon"
                fill="#ee6565"
              ></VueIcon>
              <svg
                width="18px"
                viewBox="0 0 26.349 26.35"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.WAITING &&
                  initiator.notificationSent
                "
                fill="#FDCC05"
              >
                <g>
                  <g>
                    <circle cx="13.792" cy="3.082" r="3.082" />
                    <circle cx="13.792" cy="24.501" r="1.849" />
                    <circle cx="6.219" cy="6.218" r="2.774" />
                    <circle cx="21.365" cy="21.363" r="1.541" />
                    <circle cx="3.082" cy="13.792" r="2.465" />
                    <circle cx="24.501" cy="13.791" r="1.232" />
                    <path
                      d="M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05
			C6.902,18.996,5.537,18.988,4.694,19.84z"
                    />
                    <circle cx="21.364" cy="6.218" r="0.924" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </VList>
      </VCardText>
    </VCard>
    <ShowRejectedItemDetailsDialog
      ref="showRejectedItemDetailsRef"
    ></ShowRejectedItemDetailsDialog>
  </VDialog>
</template>

<script>
import {
  INITIATOR_STATUS_TYPE,
  contractItemStatus,
} from "@/utils/constants.js";
import ShowRejectedItemDetailsDialog from "@/components/division/ShowRejectedItemDetailsDialog.vue";
import { trueSet } from "@/utils/pureFunctions.js";
const CONTRACT_ITEM = {
  contractItemId: null,
  statusType: null,
  productName: null,
  productGroupName: null,
  productTypeName: null,
  attrs: null,
  contractItemCount: null,
  unit_type_name: null,
};
export default {
  name: "DivisionShowItemDialog",
  data() {
    return {
      dialog: false,
      contractItem: {
        ...CONTRACT_ITEM,
      },
      /**
       * @typedef {Object} Initiator
       * @property {string} statusType
       *
       * @type Initiator[]
       */
      initiators: [],
    };
  },
  components: {
    ShowRejectedItemDetailsDialog,
  },
  computed: {
    INITIATOR_STATUS_TYPE() {
      return INITIATOR_STATUS_TYPE;
    },
    contractItemStatus() {
      return contractItemStatus;
    },
    statusColor() {
      switch (this.contractItem.statusType) {
        case this.INITIATOR_STATUS_TYPE.ACCEPTED:
          return "#36C281";
        case this.INITIATOR_STATUS_TYPE.REJECTED:
          return "#ee6565";
        case this.INITIATOR_STATUS_TYPE.PART_ACCEPTED:
          return "#01617F";
        case this.INITIATOR_STATUS_TYPE.NEW:
          return "#FDCC05";
        default:
          return "#FDCC05";
      }
    },
  },
  methods: {
    openRejectItemDetailsDialog(initiatorId) {
      const { showRejectedItemDetailsRef } = this.$refs;
      if (showRejectedItemDetailsRef) {
        showRejectedItemDetailsRef.open(initiatorId);
      }
    },
    close() {
      this.dialog = false;
    },
    async getInitiator() {
      this.showLoading();
      try {
        let contractItemId = this.contractItem.contractItemId;
        const {
          data: { data },
        } = await this.$http.get("user-agreement/get-initsiators", {
          params: { contractItemId },
        });
        this.initiators = data.map((item) => {
          let notificationSent = trueSet(item.notificationSent);
          item.notificationSent = notificationSent;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open({
      contractItemId,
      statusType,
      productName,
      productGroupName,
      productTypeName,
      attrs,
      contractItemCount,
      unit_type_name,
    }) {
      this.contractItem = {
        contractItemId,
        statusType,
        productName,
        productGroupName,
        productTypeName,
        attrs,
        contractItemCount,
        unit_type_name,
      };
      this.dialog = true;
      this.getInitiator();
    },
  },
};
</script>
